var o=function(E){return E.HETERO="hetero",E.BISEXUAL="bisexual",E.HOMOSEXUAL="homosexual",E}({});export{o as SexualOrientation};